<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'goodsTypeList' }">商品分类</router-link>
                </li>
                <li>
                    {{saveModel.level}}级分类
                </li>
                <li class="active">(添加/修改)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules" label-width="100px" style="width:80%;margin:0 auto;">
                <el-form-item label="一级分类:" v-show="saveModel.level === 2">
                    <el-select v-model="saveModel.parentTypeId" clearable>
                        <el-option v-for="(item, index) in goodsTypeOnes" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称:" prop="name">
                    <el-input v-model="saveModel.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                 <el-form-item label="图标:">
                    <el-upload :action="serverUrl + '/file/upload'" :on-success="uploadSuccess" :data="uploadData" :limit="1">
                        <el-button size="small" type="primary">上传</el-button>
                        <div slot="tip" class="el-upload__tip">请上传200*200的图片</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="位置:">
                  <el-input type="number" v-model="saveModel.sequence" placeholder="请输入位置"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="saveGoodsType('formName')">确认</el-button>
                    <el-button size="small" @click="resetForm('formName')">重置</el-button>
                    <el-button size="small" @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            saveModel:{},
            goodsTypeOnes: [],
            uploadData: { folder: '', fileNamePre: 'GoodsTypePlatform' },
            serverUrl: config.hostUrl,
            rules: {
                name: [{ required: true, message: "请输入名称", trigger: "blur" }],
            },
        }
    },
    created() {
        let _this = this;
        _this.saveModel.level = _this.$route.query.level;
        if(_this.$route.query.parentTypeId){
            _this.saveModel.parentTypeId = _this.$route.query.parentTypeId;
        }
        var _goodsTypeId = _this.$route.query.goodsTypeId;
        if (_goodsTypeId) {
            _this.detailGoodsType(_goodsTypeId).then((res)=>{
                if(res.item && res.item.level == 2){
                    _this.findGoodsTypeOne();
                }
            });
        } else if(_this.saveModel.level == 2){
            _this.findGoodsTypeOne();
        }
    },
    methods: {
        uploadSuccess(res, file) {
            let _this = this;
            _this.saveModel.iconPath = res.msg;
        },
        saveGoodsType(formName) {
            let _this = this;
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.$common.ajaxRequest({
                        url: 'goodsType/saveGoodsType',
                            data: _this.saveModel,
                            success: res=> {
                                _this.$message({
                                    message: '保存成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: function() {
                                        _this.$router.push({ name: 'goodsTypeList' });
                                    }
                                });
                            }
                    });
                }else{
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        detailGoodsType(_goodsTypeId) {
            let _this = this;
            return new Promise((reslove, reject)=>{
                _this.$common.ajaxRequest({
                    url: 'goodsType/detailGoodsType',
                    data: {goodsTypeId: _goodsTypeId},
                    success:res=>{
                        reslove(res);
                        _this.saveModel = res.item;
                    }
                });
            });
        },
        findGoodsTypeOne() {
            let _this = this;
            _this.$common.ajaxRequest({
                url: 'goodsType/pageGoodsTypeByManager',
                data: {level: 1},
                repeatKey:Math.random(),
                success: res=> {
                    _this.goodsTypeOnes = res.items;
                }
            });
        },
    },
}
</script>
<style scoped>
</style>